import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';



import PageLoading from '../components/PageLoading';
import right_corner_style from '../utils/right-corner-style';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';



import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';


import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import RefreshIndicator from 'material-ui/RefreshIndicator';


import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SimCardIcon from 'material-ui/svg-icons/hardware/sim-card';

import { clearUIMessage } from '../utils/UIMessageBoxes.js';
import SimCard from '../DataModel/SimCard';

const rowStyle = {
  cursor: 'pointer'
}
const refresh = {
  display: 'inline-block',
  position: 'relative',
}

export default
@observer class SimCardPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }
  constructor(props){
    super(props)

    this.state = { 
      showReserved: false,
      shortIccid: true,
      updatingSimCards: []
    }
  }
  componentWillUpdate(){
    AppModel.simCardForm.reset();
    AppModel.simCardLocationData = {};
    AppModel.simCardUsage = [];
  }
  handleOpen(dialog){
    let self = this;
    return function() {
      self.setState({[dialog]: true});
    }
  };

  handleClose(dialog) {
    let self = this;
    return function() {
      self.setState({[dialog]: false});
    }
  };

  updateTextField(form, key) {
    return function(e, value) {
      if(key == 'iccid' || key == 'lastIccid'){
        value = value.replace(/\D/g,'');
      }
      form[key] = value;
    }
  }

  /* setSortedField(field) {
    if(AppModel.sortField == field){
      AppModel.direction = !AppModel.direction
    }else{
      AppModel.sortField = field
    }
  } */
  updateCheck() {
    var self = this;
    return function(event) {
      var field = event.target.dataset.propname;
      var checked = event.target.checked;
      self.setState({ [field]: checked })
      
    }
  }
  handleRowSelection = (row) => {
    AppModel.simCardForm.reset()
    AppModel.roamingStatus = null;
    let sim = AppModel.sortedSimCards[row]
    AppModel.simCardForm.simCard = new SimCard(sim);       
    AppModel.simCardUsage = []; 
    if(sim.phone == undefined){
      AppModel.simCardForm.newDataPackage = 6001; // Hardcoding default value
      AppModel.simCardForm.newRoaming = true;
    }
    this.context.router.push(`/simcards/simcard/${sim.phone}`);
  }

  search(e, value) {
    AppModel.searchTerm = value;
  }


  simCardList() {
    
    return (
      <TableBody
        deselectOnClickaway={false}
        displayRowCheckbox={false}
        showRowHover={true}
      >
        {AppModel.sortedSimCards.map((simcard) => {
          let iccid = this.state.shortIccid ? simcard.iccid.slice(-7) : simcard.iccid;
          
          return (
            <TableRow key={simcard.iccid} style={{cursor: "pointer"}}>
              <TableRowColumn style={{width:30}}><SimCardIcon/></TableRowColumn>
              <TableRowColumn>{iccid}</TableRowColumn>
              <TableRowColumn>{simcard.name || simcard.machineId}</TableRowColumn>
              <TableRowColumn>{simcard.status}</TableRowColumn>
              <TableRowColumn>{simcard.data}</TableRowColumn>
            </TableRow>
          )
        })}
      </TableBody>
    )
  }

  //<PageLoading loading={AppModel.fetchingJobList}>
  // </PageLoading>

  render() {

    const registerActions = [
      <FlatButton
        label={uiMsg('SC_ADD',"Add")}
        primary={true}
        keyboardFocused={true}
        onClick={this.registerSimCard}
      />,
    ];
    return (
        <PageLoading loading = {AppModel.fetchingSimCards}>

        <Toolbar style={{ position: 'sticky', top: 0, zIndex: 100, height: 72}}>
          <ToolbarGroup style={{alignItems: "center", width: 200}}>
              <Checkbox
                data-propname="shortIccid"
                label={uiMsg('SC_SHORT_ICCID',"Short ICCID")}
                checked={this.state.shortIccid}
                onCheck={this.updateCheck()}
                style={{marginTop: 24}}
              />
          </ToolbarGroup>
          <ToolbarGroup>
            <TextField floatingLabelText={uiMsg('SEARCH',"Search")}
                   hintText={uiMsg('SC_SEARCH_HINT',"ICCID, Name, Status")}
                   fullWidth={false}
                   onChange={this.search}
                   style={{scale:0.5}}
            />
          </ToolbarGroup>
        </Toolbar>

          <Table onRowSelection={this.handleRowSelection}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn style={{width:30}}></TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('SC_ICCID',"ICCID")}</TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('SC_NAME',"Name")}</TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('SC_STATUS',"Status")}</TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('SCD_DATA_PACKAGE',"Data package")}</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            {AppModel.fetchingSimCards ? null : this.simCardList() }
          </Table>



        </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/SimCardPage.jsx
 **/